import {EtsyList, EtsyShopReadinessStateDefinition} from '@coolcolduk/etsy';
import getAxios from '../../util/axios/getAxios';

export default async function fetchShopReadinessStateDefinitions(
  token: string,
  shopRecordId: string,
): Promise<EtsyList<EtsyShopReadinessStateDefinition>> {
  const response = await getAxios('etsy', {token}).get<EtsyList<EtsyShopReadinessStateDefinition>>(
    'getShopReadinessStateDefinitions',
    {params: {shopRecordId}},
  );
  return response.data;
}
